/**
 * Фильтр проектов мастер-карты по статусам (только для таблицы, не для ИТОГО).
 */

export function normalizeStatus(status) {
  return (status || '').trim();
}

/** @param {Set<string>|null|undefined} selectedStatuses */
export function isStatusFilterActive(selectedStatuses) {
  return selectedStatuses instanceof Set && selectedStatuses.size > 0;
}

/**
 * @param {Array<{current_status?: string}>} projects
 * @param {Set<string>|null|undefined} selectedStatuses — пустой/null = все
 * @returns {Array}
 */
export function filterProjectsByStatuses(projects, selectedStatuses) {
  const list = projects || [];
  if (!isStatusFilterActive(selectedStatuses)) return list;
  const normalizedSelected = new Set(
    [...selectedStatuses].map((status) => normalizeStatus(status)).filter(Boolean)
  );
  return list.filter((project) =>
    normalizedSelected.has(normalizeStatus(project.current_status))
  );
}
